import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { brazilStates } from '@app/shared/mocks/ufs';

@Component({
  selector: 'app-dialog-edit-uf',
  templateUrl: './dialog-edit-uf.component.html',
  styleUrls: ['./dialog-edit-uf.component.sass'],
})
export class DialogEditUfComponent implements OnInit {
  form!: FormGroup;
  states: { sigla: string; nome: string }[];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogEditUfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idTrade: string }
  ) {
    this.states = Object.keys(brazilStates).map((sigla) => ({
      sigla,
      nome: brazilStates[sigla],
    }));
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      uf: ['', Validators.required],
      city: ['', Validators.required],
    });
  }

  onSubmit() {
    this.dialogRef.close(this.form.value);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
